"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobileDetection_1 = require("../utils/mobileDetection");
var MinimizedDock = function (_a) {
    var onRestore = _a.onRestore;
    var isMobile = (0, mobileDetection_1.useIsMobile)();
    if (isMobile) {
        // Mobile version: Only show brandmark image
        return (react_1.default.createElement("div", { onClick: onRestore, role: "button", "aria-label": "Open Assistant", style: {
                position: "fixed",
                bottom: 10,
                right: 10,
                cursor: "pointer",
                zIndex: 1100,
                userSelect: "none",
                border: "none",
                boxShadow: "none",
            } },
            react_1.default.createElement("img", { src: "assets/Fermaglo_Image01.png", alt: "Glo Assistant", width: 60, height: 60, style: {
                    borderRadius: "50%",
                    objectFit: "contain",
                    background: "#F8FAFC",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    border: "2px solid #fff",
                } })));
    }
    // Desktop version: Original layout
    return (react_1.default.createElement("div", { onClick: onRestore, role: "button", "aria-label": "Open Assistant", style: {
            position: "fixed",
            bottom: 10,
            right: 0,
            cursor: "pointer",
            zIndex: 1100,
            userSelect: "none",
            border: "none",
            boxShadow: "none",
        } },
        react_1.default.createElement("div", { style: {
                position: "relative",
                width: 320,
                height: 210,
                border: "none",
                boxShadow: "none",
            } },
            react_1.default.createElement("img", { src: "assets/Fermaglo_Image04(Filled).svg", alt: "", "aria-hidden": "true", style: {
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    pointerEvents: "none",
                    userSelect: "none",
                    border: "none",
                    boxShadow: "none",
                } }),
            react_1.default.createElement("div", { style: {
                    position: "absolute",
                    inset: "0px 5px 30px 15px",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                } },
                react_1.default.createElement("div", { style: { maxWidth: 150 } },
                    react_1.default.createElement("div", { style: { fontWeight: 700, color: "#4B2A7A", fontSize: 18 } }, "I\u2019m Glo!"),
                    react_1.default.createElement("div", { style: { color: "#5B6470", fontSize: 13, lineHeight: 1.4 } },
                        "Here to guide you with products,",
                        react_1.default.createElement("br", null),
                        "support, or getting started in community.")),
                react_1.default.createElement("img", { src: "assets/Fermaglo_Image01.png", alt: "Glo mark", width: 64, height: 64, style: { objectFit: "contain" } })))));
};
exports.default = MinimizedDock;
